var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "UiDrawer" }, [
    _vm.value
      ? _c("div", {
          staticStyle: {
            position: "absolute",
            "z-index": "100",
            left: "0",
            top: "0",
            right: "0",
            bottom: "0",
            "background-color": "rgba(0,0,0,0.4)",
          },
          on: { click: _vm.toggleDrawer },
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.value
      ? _c(
          "div",
          {
            staticClass: "p-4",
            staticStyle: {
              "z-index": "200",
              position: "fixed",
              right: "0",
              top: "0",
              bottom: "0",
              "max-width": "400px",
              padding: "0px",
              "background-color": "white",
              border: "1px solid lightgrey",
            },
          },
          [
            _c(
              "b-button",
              {
                staticClass: "btn-light btn-lg close",
                staticStyle: { cursor: "pointer" },
                attrs: { squared: "" },
                on: { click: _vm.toggleDrawer },
              },
              [
                _c("i", { staticClass: "zmdi zmdi-close fa-lg" }),
                _vm._v(" "),
                _c("span", { staticClass: "sr-only" }, [
                  _vm._v(_vm._s(_vm.$t("global.cancel"))),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("h6", { staticClass: "mb-4 pt-1 text-lg" }, [
              _vm._v(_vm._s(_vm.title)),
            ]),
            _vm._v(" "),
            _vm._t("default"),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }